module.exports = __webpack_public_path__ + "static/media/photo1.e0ac9d73.jpg";